/// <amd-module name="Feed/Legacy/Helpers/FilterHelper" />
import { Filter } from "VSSUI/Utilities/Filter";

import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { IUpstreamSettingsRowData } from "Feed/Legacy/Types/IUpstreamSettingsRowData";

export class UpstreamSettingsListFilterKeys {
    public static protocol = "protocol";
}

export function filterUpstreamSettingsList(
    filter: Filter,
    upstreamSourceRows: IUpstreamSettingsRowData[]
): IUpstreamSettingsRowData[] {
    const protocolFilter = filter.getFilterItemValue<IPackageProtocol[]>(UpstreamSettingsListFilterKeys.protocol);

    const filteredResults = upstreamSourceRows.filter(dataRow => {
        if (
            protocolFilter &&
            protocolFilter.length &&
            !protocolFilter.some(protocol => protocol.name === dataRow.protocolName)
        ) {
            return false;
        }

        return true;
    });

    return filteredResults;
}
